import type { RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { SetupIdentifier } from "consts/setups";
import { isKeyIn, when } from "util/support";
import { converStringtoArray, convertToOptions } from "util/transformers";

export const selectIsSetupsUninitialized = (identifier?: SetupIdentifier) =>
  (state: RootState) =>
    Object.is(
      when(
        isKeyIn(state.setups, identifier),
        () => state.setups[identifier!].loadingState,
        () => state.setups.tableLoadingState
      ),
      ApiState.Idle
    );

export const selectIsSetupsLoading = (identifier?: SetupIdentifier) =>
  (state: RootState) =>
    Object.is(
      when(
        isKeyIn(state.setups, identifier),
        () => state.setups[identifier!].loadingState,
        () => state.setups.tableLoadingState
      ),
      ApiState.Pending
    );
export const selectIsSetupLoading =  (state: RootState) =>
  state.setups.tableLoadingState === ApiState.Pending;

export const selectIsExportSetupsLoading = (state: RootState) =>
  state.setups.exportLoadingState === ApiState.Pending;

export const selectSetupsSlice = (identifier?: SetupIdentifier) =>
  (state: RootState) =>
    when(
      isKeyIn(state.setups, identifier),
      () => state.setups[identifier!].slice,
      () => state.setups.tableSlice
    );

export const selectSetupValue = (identifier: SetupIdentifier) =>
  (state: RootState) =>
    selectSetupsSlice(identifier)(state)?.setupValue;

export const selectDomains = (state: RootState) =>
  converStringtoArray(
    selectSetupValue(SetupIdentifier.Mors)(state)
  );

export const selectSftpImportConsumersAllowedMerchantsFolders = (state: RootState) =>
  converStringtoArray(
    selectSetupValue(SetupIdentifier.SftpImportConsumersAllowedMerchantsFolders)(state)
  );

export const selectDomainOptions = (state: RootState) =>
  convertToOptions(selectDomains(state));
